import React, { useState, useEffect } from "react";
import { VsiH4, VsiHr } from "../../styled/App.styled";
import { useVsiAppContext } from "../../stores/VsiApp";
import { useTitleFromComponent } from "../../utils/hooks";
import { Spinner } from "reactstrap";
import { minuteSecondTimeFormatter, shortDatePlusTimeFormatter } from "../../utils/gridFormatters";
import { GetAuth } from "../../utils/Verbs";
import Grid from "../../components/Grid";

const sessionColumnDefinitions = [
  {
    field: "token",
    headerName: "Token",
    hide: true
  },
  { field: "email", headerName: "User" },
  { field: "client", headerName: "Client" },
  {
    field: "lastLogin",
    headerName: "Last Login",
    cellRenderer: shortDatePlusTimeFormatter
  },
  {
    field: "ttl",
    headerName: "Time Remaining",
    cellRenderer: minuteSecondTimeFormatter
  }
];
export default function Sessions({ title }) {
  useTitleFromComponent("Sessions");
  const [isLoading, setIsLoading] = useState(true);
  const [allSessions, setAllSessions] = useState([]);
  const { user, getAccessTokenSilently } = useVsiAppContext();

  useEffect(() => {
    const getSessions = async () => {
      const token = await getAccessTokenSilently();
      GetAuth("/api/v6/login/sessions", token)
        .then(data => {
          setAllSessions(data.data);
          setIsLoading(false);
        })
        .catch(err => {
          console.error(err);
          setIsLoading(false);
        });
    };
    getSessions();
  }, []);

  return (
    <div>
      <VsiH4>{title}</VsiH4>
      <VsiHr />
      {isLoading ? <Spinner color={"primary"} /> :
        <Grid data={allSessions}
              columnDefs={sessionColumnDefinitions}
        />
      }
    </div>
  );
}
